import { render, staticRenderFns } from "./risk_assessment_results.vue?vue&type=template&id=39ca2716&"
import script from "./risk_assessment_results.vue?vue&type=script&lang=js&"
export * from "./risk_assessment_results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports